import React from 'react'
import { H1, P2 } from './ActivityStyledComponents'

const Guidelines = props => {
  const { cardDataSteps } = props
  if (cardDataSteps !== null) {
    return (
      <div style={{ padding: '0 20px' }}>
        <H1>Guidelines</H1>
        {cardDataSteps.map((item, index) => {
          return (
            <div style={{ marginTop: '18px' }} key={index}>
              <P2>Step {index + 1}</P2>
              <P2>{item.description1[0] ? item.description1[0].text : 'No data'}</P2>
            </div>
          )
        })}
      </div>
    )
  } else {
    return (
      <div style={{ padding: '0 20px' }}>
        <H1>Guidelines</H1>
        <P2>No data</P2>
      </div>
    )
  }
}

export default Guidelines
